export default __webpack_public_path__ + "static/media/OpenSansSemiBold.02a7b3cc.woff";